module.exports = __webpack_public_path__ + "img/E1 Box.62fdf643.png";